module.exports = __webpack_public_path__ + "img/t123.4fb54350.png";